import type {Workload} from "../../3-workload-analysis/model/Workload.ts";
import type {WorkloadInput} from "../../3-workload-analysis/model/WorkloadInput.ts";
import {buildWorkloadUIExport} from "../utils/workloadExport.ts";
import {download} from "../../../analysis-process/4-upload-results/download.ts";

interface DownloadWorkloadButtonProps {
    workload: Workload
    getWorkloadInput: (workload: Workload) => WorkloadInput | undefined
    label?: string
    style?: React.CSSProperties
}

/**
 * Button component to download a UI-structured export of a workload
 */
export function DownloadWorkloadButton({
    workload,
    getWorkloadInput,
    label = "Download",
    style
}: DownloadWorkloadButtonProps) {
    
    const handleDownload = () => {
        try {
            const workloadInput = getWorkloadInput(workload)
            
            if (!workloadInput) {
                alert("Could not find workload data for this workload.")
                return
            }

            // Build the UI export structure
            const uiExport = buildWorkloadUIExport(workload, workloadInput)
            
            // Generate filename
            const filename = `${workload.versionId.groupName}_${workload.versionId.projectName}_${workload.startingJob}_export.json`
                .replace(/[^a-zA-Z0-9_-]/g, '_')
            
            // Download the file
            download(uiExport, filename)
        } catch (error) {
            console.error("Failed to download workload export:", error)
            alert("Failed to download workload export. Please check the console for details.")
        }
    }
    
    return (
        <button
            onClick={handleDownload}
            style={{
                padding: '0.25rem 0.5rem',
                fontSize: '0.875rem',
                cursor: 'pointer',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                ...style
            }}
            title="Download UI export of this workload"
        >
            {label}
        </button>
    )
}
